import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { getToken, removeToken } from './auth'
import router from '@/router'

// API 基础配置
// const API_BASE_URL = 'http://192.168.0.107:8081/api/' || '/api'
// const API_BASE_URL_PRODUCTION = 'http://192.168.0.107:8081/api/'



// API 基础配置
const API_BASE_URL = 'https://drawnew.yiyutop.cn/api/' || '/api'
const API_BASE_URL_PRODUCTION = 'https://drawnew.yiyutop.cn/api/'

// 创建 axios 实例
const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 50000
})

// 导出上传接口的完整 URL
export const UPLOAD_URL = API_BASE_URL_PRODUCTION + 'admin/uploadImgOriginal'
export const UPLOAD_COMPRESSED_URL = API_BASE_URL_PRODUCTION + 'admin/uploadImg'
export const UPLOAD_LOCAL_URL = API_BASE_URL_PRODUCTION + 'admin/uploadImg'
export const UPLOAD_LOCAL_COMPRESSED_URL = API_BASE_URL_PRODUCTION + 'admin/uploadImg'
export const UPLOAD_AUDIO_LOCAL_URL = API_BASE_URL_PRODUCTION + 'admin/uploadAudioLocal'
export const UPLOAD_PRIZE_IMG_URL = API_BASE_URL_PRODUCTION + 'admin/uploadPrizeImg'

let isRedirectingToLogin = false

function redirectToLogin() {
  if (router.currentRoute.path === '/login' || isRedirectingToLogin) return
  isRedirectingToLogin = true
  router.replace('/login').catch(() => {}).finally(() => {
    isRedirectingToLogin = false
  })
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    console.log('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 二进制流响应（导出/下载模板等）直接返回，不走 code 判断
    if (response.config && response.config.responseType === 'blob') {
      return response.data
    }
    const res = response.data
    
    // 如果返回的状态码不是200，说明接口有问题
    if (res.code !== 200) {
      // 401: Token 过期或无效，需要重新登录
      if (res.code === 401) {
        removeToken()
        redirectToLogin()
        return Promise.resolve(res)
      }
      
      // 403: 判断是认证失效还是权限不足
      if (res.code === 403) {
        const msg = res.msg || ''
        if (msg.includes('认证') || msg.includes('过期') || msg.includes('失效')) {
          // 认证失效，清除Token并跳转登录页
          removeToken()
          redirectToLogin()
        } else {
          Message({
            message: msg || '无权限操作',
            type: 'error',
            duration: 5 * 1000
          })
        }
        return Promise.resolve(res)
      }

      // 408: 活动已锁定，只提示不跳转
      if (res.code === 408) {
        Message({
          message: res.msg || '该活动已锁定，不允许编辑',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.resolve(res)
      }
      
      Message({
        message: res.msg || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })
      
      return Promise.resolve(res)
    } else {
      return res
    }
  },
  error => {
    console.log('响应错误:', error)
    
    // 处理401错误（认证失败，需要重新登录）
    if (error.response && error.response.status === 401) {
      removeToken()
      Message({
        message: error.response.data?.msg || '登录已过期，请重新登录',
        type: 'warning',
        duration: 3 * 1000
      })
      redirectToLogin()
      return Promise.resolve(error.response.data || { code: error.response.status })
    }
    
    // 处理403错误：判断是认证失效还是权限不足
    if (error.response && error.response.status === 403) {
      const msg = error.response.data?.msg || ''
      if (msg.includes('认证') || msg.includes('过期') || msg.includes('失效')) {
        // 认证失效，清除Token并跳转登录页
        removeToken()
        Message({
          message: msg || '登录已过期，请重新登录',
          type: 'warning',
          duration: 3 * 1000
        })
        redirectToLogin()
      } else {
        Message({
          message: msg || '无权限操作',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.resolve(error.response.data || { code: error.response.status })
    }

    // 处理408错误（活动已锁定，只提示不跳转）
    if (error.response && error.response.status === 408) {
      Message({
        message: error.response.data?.msg || '该活动已锁定，不允许编辑',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.resolve(error.response.data || { code: error.response.status })
    }
    
    // 其他错误
    Message({
      message: t(error.response?.data?.msg || '网络请求失败，请稍后重试'),
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
